
import { useNavigate } from "react-router-dom";
import "./Errors.css"

function ServerErr({ onFocus, value, onChange }) {
    const navigate = useNavigate();
    const reloadPageHandler=()=>{
        navigate(-1)
        window.location.reload()
    }
    return (
        <>
            <div className="flex items-center justify-start w-full h-screen flex-col">
                <img src="/500.gif" alt="" />
                <p className="font-bold text-2xl text-red-500 text-center">
                    لطفا بعدا تلاش کنید
                </p>
                <div className="w-full h-[2px] bg-red-200 mt-2"></div>
                <div>
                    <button onClick={()=>reloadPageHandler()} className="border-main border-2 rounded-xl px-4 py-1 mt-2 text-center text-main">
                      بازگشت
                    </button>
                </div>
            </div>
        </>
    );
}

export default ServerErr